import { z } from 'zod';

export const planBillingSearchSchema = z.object({
    checkout_session_id: z.string().optional(),
});

export type PlanBillingSearch = z.infer<typeof planBillingSearchSchema>;
